<template>
  <social-sharing
    :url="url"
    :title="title"
    :description="description"
    inline-template
  >
    <div class="flex flex-wrap gap-2">
      <network network="linkedin">
        <button type="button" :class="btnClass">
          <i class="hf hf-linkedin" />
        </button>
      </network>
      <network network="facebook">
        <button type="button" :class="btnClass">
          <i class="hf hf-facebook" />
        </button>
      </network>
      <network network="twitter">
        <button type="button" :class="btnClass">
          <v-icon type="twitter" />
        </button>
      </network>
      <a
        :href="'mailto:?subject=' + encodeURIComponent(title) + '&body=' + url"
        :class="btnClass"
        target="_blank"
        title="Email"
      >
        <v-icon type="envelope" />
      </a>
      <el-tooltip
        :content="$t('general.copy_link_to_clipboard')"
        class="item"
        placement="top-start"
      >
        <button
          v-clipboard="url"
          :class="btnClass"
          type="button"
          class="Story__CopyLink"
          @success="$notify.success($t('success.url_copied'))"
        >
          <v-icon type="share-alt" />
        </button>
      </el-tooltip>
    </div>
  </social-sharing>
</template>

<script>
export default {
  name: 'ShareOn',
  props: {
    url: {
      type: String,
      default () {
        return this.$getUrl(this.$route.fullPath, 'hypenews', null)
      }
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    // Square, white/bordered icon button (mockup's rail share tiles).
    btnClass () {
      return 'inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-[10px] border border-solid border-line bg-white text-muted transition-colors hover:border-outline hover:text-ink'
    }
  }
}
</script>
